export default __webpack_public_path__ + "static/media/alien0944.4f69daa0.png";